import { render, staticRenderFns } from "./EditPost.vue?vue&type=template&id=31e69628&scoped=true"
import script from "./EditPost.vue?vue&type=script&lang=js"
export * from "./EditPost.vue?vue&type=script&lang=js"
import style0 from "./EditPost.vue?vue&type=style&index=0&id=31e69628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e69628",
  null
  
)

export default component.exports